export const photos = [
  {
    src: "./photos/1700559973.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700558439.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700556155.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700556084.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700555825.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700555731.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1700554882.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695959673.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695878920.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695878367.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695876630.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695873419.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695871739.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695870169.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695868211.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695803202.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695719384.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1695714810.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1695714250.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695697037.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695686335.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695629660.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1695629585.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695626132.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695624792.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695623790.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695623454.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695541143.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695540927.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695540724.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695540322.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695539734.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695538924.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695538904.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695537044.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1695525846.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691837500.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691837067.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691836474.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691836408.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691835313.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691835278.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1691831523.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691831200.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691831094.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691830598.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1691830256.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691828157.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691828126.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691828050.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691828045.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691828000.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827933.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827910.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827849.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827645.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827627.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827613.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827548.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691827522.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691826625.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691218819.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691217844.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691217747.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691216761.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691214810.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691214401.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691213653.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691213478.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691212686.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691212557.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691211425.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1691209832.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690101680.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1690101209.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690100146.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1690099794.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690099718.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690097008.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690096056.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690094045.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690093911.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690093313.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690093295.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1690092583.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689382777.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689382452.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689382117.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689381831.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689381773.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689381465.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689381123.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689380368.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689379792.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689083617.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689083474.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689082358.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689081719.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1689080751.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1687255011.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1687250782.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1687250774.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1687178720.jpg",
    width: 2,
    height: 3
  },
  {
    src: "./photos/1687178316.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1687177325.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1687011478.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1687005190.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1686927605.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1686927398.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1682754913.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1682747956.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1682747161.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1682747154.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1680336328.jpg",
    width: 3,
    height: 2
  },
  {
    src: "./photos/1680333211.jpg",
    width: 3,
    height: 2
  },
];


// WEBPACK FOOTER //
// ./src/photos.js